module.exports = __webpack_public_path__ + "img/goods-3.ed5a3cfb.png";